<template>
  <div class="container-fluid pt-0">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <div
      v-if="
        singledevice && singledevice.status === 'critical' && singledevice.stat
      "
    >
      <div :key="index" v-for="(note, index) in singledevice.stat.notes">
        <div
          v-if="note"
          class="alert alert-danger alert-dismissible fade show margin-bottom-1x p-b-20"
        >
          <div style="display: flex" class="align-items-center">
            <div class="mr-3">
              <i class="font-24 icon-bell"></i>
            </div>
            <div>
              <h5 class="alert-close mb-0">{{ $t("alert") }}</h5>
              <div class="alert-close mb-0">
                {{ note.replace(/�/g, "°") }}. {{ $t("read-on") }}
                {{ getDate(singledevice.stat.deviceTimeStamp) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- New -->
    <div class="row mb-4">
      <div class="col-sm-4 col-12">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="mb-1 mx-2 text-capitalize">
              {{ singledevice.settings.name }}
            </h4>
            <p class="gray3 font-12 mx-2">
              {{ $t("dev_type") }}:
              <strong class="text-dark">{{ singledevice.type }}</strong>
            </p>

            <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">{{ $t("dev-tag") }}</div>
              <div class="col-4 font-medium text-right mb-0">
                {{ singledevice.deviceTag }}
              </div>
            </div>
            <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">
                {{ $t("device") }} {{ $t("Imei") }}
              </div>
              <div class="col-4 font-medium text-right mb-0">
                {{ singledevice.imei }}
              </div>
            </div>
            <!-- <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0 text-capitalize">
                {{ $t("group") }}
              </div>
              <div class="col-4 font-medium text-right mb-0">
                {{ group }}
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="col-sm-4 col-12">
        <div class="card" style="overflow-y: auto; height: 100%">
          <div class="card-body">
            <div class="row py-2 px-2">
              <div
                class="col-5"
                style="display: flex"
                v-if="singledevice.type.toLowerCase() !== 'loctrack'"
              >
                <img
                  src="../../assets/images/snowflake.png"
                  alt=""
                  style="width: 28px;height:32px;"
                />
                <h2
                  class="mb-0 text-primary mb-2 font-24 ml-2"
                  v-if="singledevice.type !== 'gateway' && singledevice.stat"
                >
                  {{ singledevice.stat.temperature }}<sup>°</sup>C
                </h2>
                <h2 v-else class="text-primary mb-0">-<sup>°</sup>C</h2>
              </div>
              <div
                class="col-7 justify-content-center mb-0"
                style="display: flex; flex-direction: column"
              ></div>
              <div class="col-12 mb-0" style="display: flex;">
                <p
                  style="font-size: 0.9rem"
                  class="gray3 mb-0 font-12"
                  v-if="singledevice.stat && singledevice.stat.deviceTimeStamp"
                >
                  {{ $t("last-read") }}
                </p>
                <p
                  v-if="singledevice.stat && singledevice.stat.deviceTimeStamp"
                  style="font-size: 0.9rem"
                  class="gray3 mb-0 ml-1  font-12"
                >
                  {{ getDate(singledevice.stat.deviceTimeStamp) }}
                </p>
                <p v-else style="font-size: 0.9rem" class="gray3 mb-0">
                  {{ $t("no-read") }}
                </p>
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              v-if="
                (singledevice.type.toLowerCase() === 'mote' ||
                  singledevice.type.toLowerCase() === 'lora' ||
                  singledevice.type.toLowerCase() === 'gps-vt') &&
                  singledevice.stat
              "
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">{{ $t("humid") }}</div>
              <div class="col-4 font-medium text-right mb-0">
                <span>{{ singledevice.stat.humidity }}%</span>
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">{{ $t("batt") }}</div>
              <div class="col-4 font-medium text-right mb-0">
                <span
                  v-if="singledevice.stat && singledevice.stat.battery < 0"
                  class="red-text"
                  >{{ $t("emp") }}</span
                >
                <span
                  v-else-if="
                    singledevice.stat && singledevice.stat.battery >= 100
                  "
                  >100%</span
                >
                <span v-else-if="singledevice.stat && singledevice.stat.battery"
                  >{{ singledevice.stat.battery }}%</span
                >
                <span v-if="singledevice.charging === true" class="green-text"
                  ><i class="mdi mdi-battery-charging"></i
                ></span>
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
              v-if="singledevice.type.toLowerCase() !== 'loctrack'"
            >
              <div class="col-8 pl-0 text-muted mb-0">{{ $t("min-temp") }}</div>
              <div class="col-4 font-medium text-right mb-0">
                <span
                  >{{ singledevice.settings.minTemperature }}<sup>°</sup>C</span
                >
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
              v-if="singledevice.type.toLowerCase() !== 'loctrack'"
            >
              <div class="col-8 pl-0 text-muted mb-0">{{ $t("max-temp") }}</div>
              <div class="col-4 font-medium text-right mb-0">
                <span
                  >{{ singledevice.settings.maxTemperature }}<sup>°</sup>C</span
                >
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              v-if="singledevice.type.toLowerCase() === 'box'"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">
                {{ $t("set-point") }}
              </div>
              <div class="col-4 font-medium text-right mb-0">
                <span>{{ singledevice.settings.preset }}<sup>°</sup>C</span>
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              v-if="
                singledevice.type.toLowerCase() === 'mote' ||
                  singledevice.type.toLowerCase() === 'lora' ||
                  singledevice.type.toLowerCase() === 'gps-vt'
              "
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">
                {{ $t("min-humid") }}
              </div>
              <div class="col-4 font-medium text-right mb-0">
                <span>{{ singledevice.settings.minHumidity }}%</span>
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              v-if="
                singledevice.type.toLowerCase() === 'mote' ||
                  singledevice.type.toLowerCase() === 'lora' ||
                  singledevice.type.toLowerCase() === 'gps-vt'
              "
            >
              <div class="col-8 pl-0 text-muted mb-0">
                {{ $t("max-humid") }}
              </div>
              <div class="col-4 font-medium text-right mb-0">
                <span>{{ singledevice.settings.maxHumidity }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4 col-12" v-if="singledevice.type !== 'lora'">
        <div class="card" style="overflow-y: auto; height: 100%">
          <div class="card-body">
            <div class="row py-2 px-2">
              <div class="col-5 align-items-center" style="display: flex">
                <!-- <icon-location-filled /> -->
                <img
                  src="../../assets/images/carbon_location-filled.png"
                  alt=""
                  style="height:28px;"
                />
                <h2 class="mb-0 text-primary text-capitalize ml-1 font-24">
                  {{ $t("location") }}
                </h2>
              </div>
              <div
                class="col-7 justify-content-center mb-0"
                style="display: flex; flex-direction: column"
              ></div>
              <div class="col-12 mb-0" style="display: flex;">
                <p
                  style="font-size: 0.9rem"
                  class="gray3 mb-0 font-12"
                  v-if="singledevice.lastValidLocation && singledevice.lastValidLocation.deviceTimeStamp"
                >
                  {{ $t("last_valid_loca") }}
                </p>
                <p
                  v-if="singledevice.lastValidLocation && singledevice.lastValidLocation.deviceTimeStamp"
                  style="font-size: 0.9rem"
                  class="gray3 mb-0 ml-1  font-12"
                >
                  {{ getDate(singledevice.lastValidLocation.deviceTimeStamp) }}
                </p>
                <p v-else style="font-size: 0.9rem" class="gray3 mb-0">
                  {{ $t("no-read") }}
                </p>
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              v-if="
                (singledevice.type.toLowerCase() === 'mote' ||
                  singledevice.type.toLowerCase() === 'lora' ||
                  singledevice.type.toLowerCase() === 'gps-vt') &&
                  singledevice.lastValidLocation
              "
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">
                {{ $t("longitude") }}
              </div>
              <div class="col-4 font-medium text-right mb-0">
                <span>{{ singledevice.lastValidLocation.longitude }}</span>
              </div>
            </div>

            <div
              class="row mx-2 py-2"
              v-if="
                (singledevice.type.toLowerCase() === 'mote' ||
                  singledevice.type.toLowerCase() === 'lora' ||
                  singledevice.type.toLowerCase() === 'gps-vt') &&
                  singledevice.lastValidLocation
              "
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">{{ $t("latitude") }}</div>
              <div class="col-4 font-medium text-right mb-0">
                <span v-if="singledevice.lastValidLocation.latitude">{{
                  singledevice.lastValidLocation.latitude
                }}</span>
              </div>
            </div>

            <!-- <div
              class="row mx-2 py-2"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="col-8 pl-0 text-muted mb-0">{{ $t("location") }}</div>
              <div
                class="col-4 font-medium text-right mb-0"
                v-if="singledevice.settings.location"
              >
                {{ singledevice.settings.location }}
              </div>
            </div> -->

            <div class="col-12">
              <div
                class="d-flex align-items-center mt-3 text-primary cursor-pointer"
                @click.prevent="
                  viewonMap(
                    singledevice.lastValidLocation.latitude,
                    singledevice.lastValidLocation.longitude
                  )
                "
              >
                <p class="mb-0">{{ $t("view_on_map") }}</p>
                <img
                  src="../../assets/images/solar_arrow-up-outline.png"
                  alt=""
                  class="ml-1"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 col-12 col-md-7">
        <div class="card">
          <div class="card-body">
            <div
              class="d-flex justify-content-space-around col-md-10 col-lg-6 mx-auto"
            >
              <div class="btn-container">
                <button
                  @click="
                    tempGraph = true;
                    humiGraph = false;
                  "
                  :disabled="tempGraph == true"
                  id="graphselect"
                >
                  {{ $t("temp") }}
                </button>
              </div>
              <div class="btn-container">
                <button
                  @click="
                    tempGraph = false;
                    humiGraph = true;
                  "
                  :disabled="tempGraph == false"
                  id="graphselect"
                >
                  {{ $t("humid") }}
                </button>
              </div>
            </div>
            <div>
              <CombinedChart
                :tempGraph="tempGraph"
                :humiGraph="humiGraph"
                :stats="devicehistoryChart"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-12 col-md-5">
        <div
          class="card"
          ref="mapContent"
          id="mapCont"
          style="height: 100%; min-height: 500px"
        >
          <div
            class="card-body"
            id="map-image"
            v-if="
              devicehistoryMapPoints.start ||
                devicehistoryMapPoints.start === null
            "
          >
            <!-- <button v-on:click="reduceWidth">click</button> -->
            <!-- <DeviceRoutes :stats="devicehistoryMapPoints" v-if="isRouteOne" /> -->
            <DeviceRoutes2
              :mapPoints="devicehistoryMapPoints"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body" style="max-height: 35rem; overflow-y: auto">
        <CombinedTable
          :stats="devicehistory.data"
          :type="singledevice.type.toLowerCase()"
          :paginationMeta="devicehistory.meta"
          @pageChange="(params) => $emit('pageChange', params)"
        />
      </div>
    </div>
  </div>
</template>

<script
  src="https://maps.googleapis.com/maps/api/js?key=AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg&callback=initMap&v=weekly"
  defer
></script>
<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import moment from "moment";
// import CombinedChart from "../../components/Devices/CombinedChart";
import loadGoogleMapsApi from "load-google-maps-api";
import DeviceRoutes2 from "../../components/Devices/DeviceRoutes2";
import DeviceRoutes from "../../components/Devices/DeviceRoutes";
import CombinedTable from "../../components/Devices/CombinedTable";
import IconLocationFilled from "../../components/Iconsvg/IconLocationFilled.vue";

export default {
  name: "DeviceDetails",
  data() {
    return {
      tempGraph: true,
      humiGraph: false,
      isLoading: false,
      fullPage: true,
      lastreaddate: "",
      datecreated: "",
      apiKey: "585543c980c244aa998891066c7fe492",
      license: "",
      mssg: "",
      Errormssg: "",
      deviceOn: true,
      rate: "",
      location: "",
      isRouteOne: false,
    };
  },
  components: {
    Loading,
    CombinedChart: () =>
      import(
        /* webpackPrefetch: true */ "../../components/Devices/CombinedChart"
      ),
    DevieMap: () =>
      import(
        /* webpackPrefetch: true */ "../../components/Devices/AllDevicesMap.vue"
      ),
    DeviceRoutes,
    DeviceRoutes2,
    CombinedTable,
    IconLocationFilled,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([
      "singledevice",
      "token",
      "profile",
      "lastPageData",
      "groups",
      "devicehistoryChart",
      "devicehistoryMapPoints",
      "devicehistory",
    ]),
    getSignalStrength() {
      let val = this.singledevice.stats[this.singledevice.stats.length - 1]
        .moteAddress.signalStrength;
      function between(x, min, max) {
        return x >= min && x <= max;
      }
      let strength;
      if (between(val, -120, -95.0)) {
        strength = "Extremely Bad";
      }
      if (between(val, -95.01, -85.0)) {
        strength = "Bad";
      }
      if (between(val, -85.01, -75.0)) {
        strength = "Average";
      }
      if (between(val, -75.01, -65.0)) {
        strength = "Good";
      }
      if (between(val, -65.01, -55.0)) {
        strength = "Very Good";
      }
      if (between(val, -55.01, 0.0)) {
        strength = "Excellent";
      }

      return strength;
    },
    mapDevice() {
      const lastPosition = this.singledevice.stats[
        this.singledevice.stats.length - 1
      ];
      let devices = [
        {
          stats: {
            latitude: lastPosition.latitude,
            longitude: lastPosition.longitude,
          },
          id: this.singledevice.id,
          settings: this.singledevice?.settings,
          type: this.singledevice.type,
        },
      ];
      return devices;
    },
    group() {
      const group = this.groups.filter(
        ({ id }) => id === this.singledevice.group
      );
      if (group.length > 0) {
        return group[0].name;
      } else return "NIL";
    },
    showChart() {
      return (
        this.singledevice &&
        (this.singledevice.type == "mote" ||
          this.singledevice.type.toLowerCase() === "lora" ||
          this.singledevice.type.toLowerCase() === "gps-vt")
      );
    },
  },
  methods: {
    ...mapActions(["updatePageNumber", "getDeviceHistory"]),
    noDirection() {
      this.isRouteOne = true;
    },
    closeModal() {
      this.isOpen = false;
    },
    getDate(date) {
      return moment(date).format("ddd, MMM Do YYYY, hh:mm a");
    },
    getAddress() {
      loadGoogleMapsApi({
        key: process.env.VUE_APP_GOOGLE_API_KEY,
        libraries: ["places", "drawing", "geometry"],
      }).then(async () => {
        const lastValidLocation = this.singledevice.lastValidLocation;
        this.geocode(lastValidLocation.latitude, lastValidLocation.longitude);
      });
    },
    geocode(lat, lng) {
      const { google } = window;
      const geocoder = new google.maps.Geocoder();
      geocoder
        .geocode({ location: { lat, lng } })
        .then((response) => {
          this.location = response.results[0].address_components[1].short_name;
        })
        .catch((e) => {
          console.log(e);
          // alert(e.message);
        });
    },
    handleParams(params) {
      this.$emit("params", params);
    },
    viewonMap(lat, lng) {
      window.open(`https://google.com/maps/search/${lat},${lng}`, "_blank");
    },
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name !== "Devices" &&
      to.name != "DeviceExcursions" &&
      to.name != "DeviceSettings" &&
      to.name !== "DeviceReport"
    ) {
      this.updatePageNumber({
        lastPageNumber: 1,
        lastPage: ``,
        lastPageName: "",
      });
    }
    this.updatePageNumber({
      ...this.lastPageData,
      lastPageName: "",
    });
    next();
  },
  mounted() {
    this.updatePageNumber({
      ...this.lastPageData,
      lastPageName: "device",
    });
  },
  watch: {
    // singledevice: {
    //   handler() {
    //     this.getAddress();
    //   },
    //   deep: true,
    // },
  },
};
</script>

<style scoped>
.btn-container {
  display: flex;
  justify-content: center;
  width: 50%;
}
#graphselect {
  background-color: inherit;
  border: none;
  color: #213e7a;
  padding: 7px 25px;
  border-radius: 30px;
  outline: none;
}
#graphselect:hover {
  background-color: #213e7a;
  color: white;
}
#graphselect:disabled,
#graphselect[disabled] {
  background-color: #dee2eb;
  color: #213e7a;
}
.green-text {
  color: #213e7a;
}

.succeed {
  background: #ffe6cc;
  padding: 15px 15px 7px;
  border: 1px solid #f0ac66;
  margin-bottom: 2rem;
  border-radius: 3px;
}
.succeed p {
  color: #f0ac66;
}
</style>

<i18n>
{
	"en": {
		"add": "Added on",
		"alert": "Alert!",
		"cali": "Calibration Expriry Date",
		"dev-tag": "Device Tag",
		"emp": "Empty",
		"last-read": "Last Read on",
		"no-dev-today": "No Temperature/Humidity data available for today",
		"no-read": "No readings yet",
		"read-on": "Last read on",
		"set-point": "Set Point",
		"sig-strength": "Signal Strength"
	},
	"es": {
		"add": "Añadido",
		"alert": "¡Alerta!",
		"cali": "Date d'expiration de l'étalonnage",
		"dev-tag": "Etiqueta de dispositivo",
		"emp": "vacío",
		"last-read": "Última lectura en",
		"no-dev-today": "No hay datos de temperatura / humedad disponibles para hoy",
		"no-read": "Aún no hay lecturas",
		"read-on": "sigue leyendo",
		"set-point": "Punto fijo",
		"sig-strength": "Intensidad de señal"
	},
	"fr": {
		"add": "Ajouté sur",
		"alert": "alerte!",
		"cali": "Date d'expiration de l'étalonnage",
		"dev-tag": "Balise d'appareil",
		"emp": "vide",
		"last-read": "Dernière lecture",
		"no-dev-today": "Aucune donnée de température/humidité disponible pour aujourd'hui",
		"no-read": "Pas encore de lectures",
		"read-on": "Continuer à lire",
		"set-point": "Point de consigne",
		"sig-strength": "Force du signal"
	},
	"sw": {
		"add": "Imeongezwa",
		"alert": "Tahadhari!",
		"cali": "Tarehe ya Kusafirishwa kwa Urekebishaji",
		"dev-tag": "Lebo ya Kifaa",
		"emp": "tupu",
		"last-read": "Iliyosomwa Mwisho",
		"no-dev-today": "Hakuna data ya Halijoto/Unyevu inayopatikana kwa leo",
		"no-read": "Bado hakuna masomo",
		"read-on": "Iliyosomwa mwisho",
		"set-point": "Weka Pointi",
		"sig-strength": "Nguvu ya Ishara"
	}
}
</i18n>
